import { render, staticRenderFns } from "./AwardDetailDialog.vue?vue&type=template&id=5f1f081a&scoped=true"
import script from "./AwardDetailDialog.vue?vue&type=script&lang=js"
export * from "./AwardDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./AwardDetailDialog.vue?vue&type=style&index=0&id=5f1f081a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f081a",
  null
  
)

export default component.exports